import { Modal } from "antd";
import { EditableContext } from "../../common/EditableContextProvider";
import { useContext, useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import rubros from './marcas.json';
import { isString } from "lodash";

const FormMarca = () => {
    const { context } = useContext(EditableContext);

    useEffect(() => {
        if(!context.form.opened) {
            context.form.editItem.set(context.form.defaultItem);
        }
    }, [context.form.opened]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        await context.form.send(context.form.editItem.item);
    }

    return (
        <Modal
            title="Formulario"
            closable={{ "aria-label": "Custom Close Button" }}
            open={context.form.opened}
            // onOk={handleOk}
            onCancel={context.form.hide}
            footer={null}
        >
            <form name="form1"
                onSubmit={handleSubmit}

            >
                <div className="mb-2">
                    <span>Nombre:</span>
                    <input type="text" className="form-control form-control-sm"
                        value={context.form.editItem.item.nombre}
                        onChange={(e) => context.form.editItem.set(prev => ({...prev, nombre: e.target.value }))}
                        required
                    />
                </div>
                <div className="mb-2">
                    <span>Rubro:</span>
                    <select name="rubro" id="rubro" className="form-select form-select-sm"
                        value={context.form.editItem.item.rubro}
                        onChange={(e) => context.form.editItem.set(prev => ({...prev, rubro: e.target.value }))}
                        required
                    >
                        <option value="">-- Seleccionar --</option>
                        {
                            rubros.map((rubro) => (
                                <option key={rubro.id} value={rubro.nombre}>{rubro.nombre}</option>
                            ))
                        }
                    </select>
                </div>
                <div className="mb-2">
                    <span>Marca antigua:</span>
                    {
                        (context.form.editItem.item.marca_antigua && isString(context.form.editItem.item.marca_antigua) && context.form.editItem.item.id) ?
                        (
                            <div className="text-center border border-secondary p-1 position-relative">
                                <div className='position-absolute top-0 start-0 p-1'>
                                    <button className="btn btn-sm btn-outline-danger px-1 py-0"
                                        title='Eliminar' type='button'
                                        onClick={() => { context.deleteMarcaAntigua(); }}
                                    >
                                        <i className="fas fa-xmark"></i>
                                    </button>
                                </div>
                                <img src={`/storage/${context.form.editItem.item.marca_antigua}`} style={{ maxHeight: '200px', maxWidth: '200px' }} />
                            </div>
                        ) :
                        (
                            <>
                                <input type="file" className="form-control form-control-sm"
                                    accept="image/*"
                                    onChange={(e) => context.form.editItem.set(prev => ({...prev, marca_antigua: e.target.files[0]}))}
                                />
                                <p className="text-primary">{ context.form.editItem.item.marca_antigua? `[${context.form.editItem.item.marca_antigua?.name}]` : ''}</p>
                            </>
                        )
                    }
                </div>
                <div className="mb-2">
                    <span>Marca nueva:</span>
                    {
                        (context.form.editItem.item.marca_nueva && isString(context.form.editItem.item.marca_nueva)  && context.form.editItem.item.id) ?
                        (
                            <div className="text-center border border-secondary p-1 position-relative">
                                <div className='position-absolute top-0 start-0 p-1'>
                                    <button className="btn btn-sm btn-outline-danger px-1 py-0"
                                        title='Eliminar' type='button'
                                        onClick={() => { context.deleteMarcaNueva(); }}
                                    >
                                        <i className="fas fa-xmark"></i>
                                    </button>
                                </div>
                                <img src={`/storage/${context.form.editItem.item.marca_nueva}`} style={{ maxHeight: 200, maxWidth: '200px' }} />
                            </div>
                        ) :
                        (
                            <>
                                <input type="file" className="form-control form-control-sm"
                                    accept="image/*"
                                    onChange={(e) => context.form.editItem.set(prev => ({...prev, marca_nueva: e.target.files[0]}))}
                                />
                                <p className="text-primary">{ context.form.editItem.item.marca_nueva? `[${context.form.editItem.item.marca_nueva?.name}]` : ''}</p>
                            </>
                        )
                    }

                </div>

                <div className="mb-2">
                    <span>Shop:</span>
                    <input type="text" className="form-control form-control-sm"
                        value={context.form.editItem.item.shop}
                        onChange={(e) => context.form.editItem.set(prev => ({...prev, shop: e.target.value }))}
                    />
                </div>
                <div className="mb-2">
                    <span>Facebook:</span>
                    <input type="text" className="form-control form-control-sm"
                        value={context.form.editItem.item.facebook}
                        onChange={(e) => context.form.editItem.set(prev => ({...prev, facebook: e.target.value }))}
                    />
                </div>
                <div className="mb-2">
                    <span>Instagram:</span>
                    <input type="text" className="form-control form-control-sm"
                        value={context.form.editItem.item.instagram}
                        onChange={(e) => context.form.editItem.set(prev => ({...prev, instagram: e.target.value }))}
                    />
                </div>
                <div className="mb-2">
                    <span>TikTok:</span>
                    <input type="text" className="form-control form-control-sm"
                        value={context.form.editItem.item.tiktok}
                        onChange={(e) => context.form.editItem.set(prev => ({...prev, tiktok: e.target.value }))}
                    />
                </div>
                <div className="mb-2">
                    <span>Whatsapp:</span>
                    <input type="text" className="form-control form-control-sm"
                        value={context.form.editItem.item.whatsapp}
                        onChange={(e) => context.form.editItem.set(prev => ({...prev, whatsapp: e.target.value }))}
                    />
                </div>

                <div className="mb-2 text-center">
                    <ReCAPTCHA
                        sitekey="6LeuhXIlAAAAAFsz6LTbhcqgKC-QwyGGI47Hy99y"
                        value={context.form.editItem.item.captcha}
                        onChange={(value) => context.form.editItem.set(prev => ({...prev, captcha: value}))}
                    />
                </div>

                <div className="mb-2 text-center">
                    <button type="submit" className="btn btn-sm btn-dark w-75"
                        disabled={context.loading.form}
                    >
                        { context.loading.form ? 'Enviando...' : 'Enviar' }
                    </button>
                </div>

            </form>
        </Modal>
    );
};

export default FormMarca;
